const INTENT_ONBOARDING_SIGNUP_RECEIPT_KEY = "mem.onboarding.intent_v1.fresh_web_signup";
const INTENT_ONBOARDING_SIGNUP_RECEIPT_MAX_AGE_MS = 24 * 60 * 60 * 1000;

interface IntentOnboardingSignupReceipt {
  accountId?: string;
  email?: string;
  recordedAtMs: number;
}

const normalizeEmail = (email: string): string => email.trim().toLowerCase();

export const writeIntentOnboardingSignupReceipt = ({
  accountId,
  email,
}: {
  accountId?: string;
  email?: string;
}): void => {
  try {
    const receipt: IntentOnboardingSignupReceipt = {
      accountId,
      email: email ? normalizeEmail(email) : undefined,
      recordedAtMs: Date.now(),
    };
    localStorage.setItem(INTENT_ONBOARDING_SIGNUP_RECEIPT_KEY, JSON.stringify(receipt));
  } catch {
    // Assignment is fail-closed when browser storage is unavailable.
  }
};

export const hasIntentOnboardingSignupReceipt = ({
  accountId,
  email,
  nowMs = Date.now(),
}: {
  accountId: string;
  email: string;
  nowMs?: number;
}): boolean => {
  try {
    const raw = localStorage.getItem(INTENT_ONBOARDING_SIGNUP_RECEIPT_KEY);
    if (!raw) return false;

    const receipt = JSON.parse(raw) as Partial<IntentOnboardingSignupReceipt>;
    if (
      typeof receipt.recordedAtMs !== "number" ||
      nowMs - receipt.recordedAtMs < 0 ||
      nowMs - receipt.recordedAtMs > INTENT_ONBOARDING_SIGNUP_RECEIPT_MAX_AGE_MS
    ) {
      localStorage.removeItem(INTENT_ONBOARDING_SIGNUP_RECEIPT_KEY);
      return false;
    }

    return receipt.accountId === accountId || receipt.email === normalizeEmail(email);
  } catch {
    return false;
  }
};

export const clearIntentOnboardingSignupReceipt = (): void => {
  try {
    localStorage.removeItem(INTENT_ONBOARDING_SIGNUP_RECEIPT_KEY);
  } catch {
    // noop
  }
};
